import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'gio-loading-page',
  template: `
    <mat-progress-bar *ngIf="mode !== 'spinner'"  [color]="color" [mode]="mode == 'ball' ? 'indeterminate' : mode" [value]="value">
    </mat-progress-bar>

    <div class="localpage-content primary-color">
      <mat-spinner *ngIf="mode=='spinner'" [color]="color"></mat-spinner>

      <div *ngIf="mode=='ball'" class='ball'>
        <div></div>
      </div>

      <div *ngIf="title gioco-font" class="title text-center" [innerHTML]="title"></div>
      <div *ngIf="subtitle" class="subtitle text-center" [innerHTML]="subtitle"></div>
      <div *ngIf="textHTML" class="info text-center" [innerHTML]="textHTML"></div>

    </div>
  `,
  styleUrls: ['./loading-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoadingPageComponent {
  @Input() title = 'Aguarde...';
  @Input() subtitle = '';
  @Input() textHTML = '';

  @Input() mode: 'determinate' | 'indeterminate' | 'query' | 'spinner' | 'ball' = 'ball';
  @Input() value: number;
  @Input() color: 'primary' | 'accent' | 'warn' = 'warn';

  constructor() { }

}
